import { render, staticRenderFns } from "./StoreProductBody.vue?vue&type=template&id=78dbda1a&scoped=true&"
import script from "./StoreProductBody.vue?vue&type=script&lang=js&"
export * from "./StoreProductBody.vue?vue&type=script&lang=js&"
import style0 from "./StoreProductBody.vue?vue&type=style&index=0&id=78dbda1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dbda1a",
  null
  
)

export default component.exports